import { useEffect, useState } from 'react';

export function LotterySettlingView() {
  const [dots, setDots] = useState('');

  // Animated dots effect
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev === '...') return '';
        return prev + '.';
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="space-y-8">
      {/* Main Content Container */}
      <div
        className="p-12 rounded-xl text-center space-y-6"
        style={{
          border: '2px solid rgba(80, 228, 249, 0.3)',
          background: 'linear-gradient(135deg, rgba(81,228,248,0.15) 0%, rgba(1,74,92,0.4) 100%)',
        }}
      >
        {/* Spinning Icon */}
        <div className="flex justify-center">
          <div
            className="animate-spin"
            style={{
              animation: 'spin 2s linear infinite',
            }}
          >
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="40"
                cy="40"
                r="35"
                stroke="url(#gradient)"
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray="20 200"
                fill="none"
              />
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#50E4F9" />
                  <stop offset="50%" stopColor="#7239EE" />
                  <stop offset="100%" stopColor="#FEBB01" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2
          className="text-4xl md:text-5xl"
          style={{
            fontFamily: 'Hyperspace Race Capsule, cursive',
            fontWeight: 900,
            color: '#FFFFFF',
          }}
        >
          CALCULATING REWARDS{dots}
        </h2>

        {/* Description */}
        <p
          className="text-lg text-white/80 max-w-2xl mx-auto"
          style={{
            fontFamily: 'Outfit, sans-serif',
            fontWeight: 500,
          }}
        >
          Please check back later for results.
        </p>

        {/* Status Badge */}
        <div className="flex justify-center pt-4">
          <div
            className="inline-flex items-center gap-3 px-6 py-3 rounded-full"
            style={{
              background: 'rgba(38, 38, 38, 0.9)',
              border: '2px solid #FEBB01',
            }}
          >
            <div className="flex items-center gap-2">
              {/* Pulsing indicator */}
              <div
                className="w-3 h-3 rounded-full"
                style={{
                  background: '#FEBB01',
                  animation: 'pulse 1.5s ease-in-out infinite',
                }}
              />
              <span
                className="text-base"
                style={{
                  fontFamily: 'Outfit, sans-serif',
                  fontWeight: 700,
                  color: '#FEBB01',
                }}
              >
                SETTLING
              </span>
            </div>
          </div>
        </div>

        {/* Info Box */}
        <div
          className="mt-8 p-6 rounded-lg max-w-xl mx-auto"
          style={{
            background: 'rgba(0, 0, 0, 0.3)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-1">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
                    stroke="#50E4F9"
                    strokeWidth="2"
                  />
                  <path
                    d="M10 6V10L12 12"
                    stroke="#50E4F9"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <p
                className="text-sm text-white/70 text-left"
                style={{
                  fontFamily: 'Outfit, sans-serif',
                  fontWeight: 400,
                }}
              >
                Rewards are being calculated. This may take some time.
              </p>
            </div>
          </div>
        </div>
      </div>

	  <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.5;
            transform: scale(1.2);
          }
        }
	      `}</style>
    </div>
  );
}
